import './index.scss';
import React, { Fragment, useMemo } from 'react';
import { ICustomAdvancedTableRenderConfig, IFooterBtnInfo, IColumnsExpandInfo } from '../../interface';
import { Button, Tooltip } from '@umu/umu-design';
import { If } from 'common/src/components';
import { getContentElement } from '../../dataFlow/element';
import { Checkbox } from '@umu/design-base';

interface IProps<T> {
    index: number;
    value: keyof T | string;
    info: T;
    isCheckbox?: boolean;
    configInfo: ICustomAdvancedTableRenderConfig;
    expandInfo: IColumnsExpandInfo;
}
const RenderConfig = <T extends object>(props: IProps<T>) => {
    const { configInfo, value, info, isCheckbox = false, expandInfo } = props;
    const { checkInfo, checkKey = '' } = expandInfo || {};
    const { type, config = {}, tooltipConfig: tmpTooltipConfig, className = 'render-detail' } = configInfo;
    const tooltipConfig = tmpTooltipConfig?.getConfigInfo
        ? tmpTooltipConfig.getConfigInfo({ value, info })
        : tmpTooltipConfig;
    const isShowTooltip = useMemo(() => {
        return tooltipConfig && !!tooltipConfig.isShow;
    }, [tooltipConfig]);
    const tmpConfig = config?.getConfigInfo ? config.getConfigInfo({ value, info }) : config;
    const tmpType = config?.getType ? config.getType({ value, info }) : type;
    const params = {
        info,
        value,
    };
    const ele = getContentElement(
        {
            type: tmpType,
            config: tmpConfig,
        },
        params,
    );
    const contentPrefix = tmpConfig?.prefix ? getContentElement(tmpConfig.prefix, params) : '';
    const contentSuffix = tmpConfig?.suffix ? getContentElement(tmpConfig.suffix, params) : '';
    const contentElement =
        configInfo?.onClick || configInfo.className ? (
            <div
                onClick={() =>
                    configInfo?.onClick &&
                    configInfo?.onClick({
                        info,
                        value,
                    })
                }
                className={configInfo.className || ''}
            >
                {ele}
            </div>
        ) : (
            <Fragment>{ele}</Fragment>
        );

    const getToolTipInfo = () => {
        if (!isShowTooltip) {
            return '';
        }
        const {
            showTitle = false,
            content: tooltipContent = '',
            titleContent = '',
            footerContent = { btnList: [] },
        } = tooltipConfig || {};
        return (
            <div className="custom-advanced-table-column-render-tooltip-zone">
                <If condition={!!showTitle}>{contentElement}</If>
                {getContentElement(titleContent, params)}
                {getContentElement(tooltipContent, params)}
                <If condition={(footerContent?.btnList).length > 0}>
                    <div className="custom-advanced-table-column-render-tooltip-footer">
                        {footerContent.btnList.map((item: IFooterBtnInfo, index: number) => {
                            const { label = '', ...rest } = item;
                            return (
                                <Button key={index} {...rest}>
                                    {label}
                                </Button>
                            );
                        })}
                    </div>
                </If>
            </div>
        );
    };
    const checkKeyValue = info[checkKey as unknown as keyof T] as unknown as string;
    return (
        <div className={`render-content ${className}-content`}>
            {contentPrefix}
            <Tooltip placement="bottom" destroyTooltipOnHide title={getToolTipInfo()} {...tooltipConfig?.config}>
                <div className="render-content-info">
                    <If condition={isCheckbox}>
                        <Checkbox
                            checked={checkInfo.isSelected(checkKeyValue)}
                            onClick={() => checkInfo.toggle(checkKeyValue)}
                            className="render-content-info-checkbox"
                        />
                    </If>
                    {contentElement}
                </div>
            </Tooltip>
            {contentSuffix}
        </div>
    );
};
export { RenderConfig };
